import { log } from '../helpers';
import { getState, setState } from '../core';

// go into error mode with optionally reverting what the user wanted to do.

export const fail = (bookmarked: boolean | null = null) => {
  const { status, sessionLoggedIn } = getState();

  if (status === 'error') {
    return log('already failed');
  }

  if (!sessionLoggedIn) {
    setState({
      status: 'error',
      article: 'not-logged-in',
    });
    return;
  }

  if (bookmarked !== null) {
    // do the inverse of the intended operation.
    setState({
      status: 'error',
      article: bookmarked ? 'not-bookmarked' : 'bookmarked',
    });
    return;
  }

  setState({
    status: 'error',
  });
};
